/* eslint-disable indent */
import { isEmptyObject } from 'libs/utils';

const mOperations: object = {
  CREATE_BLANK_STOCK_ORDER_DROP: (params: object) => {
    const query = `mutation CreateBlankStockOrderDrop ($data: BlankStockOrderDropInput!) {
      createBlankStockOrderDrop(data: $data) {
          id
          blank_type
          blank_color
          blank_supplier {
            id
            name
          }
          stock_order_ref
          stock_cost_price
          stock_order_quantity {
            xs
            youth_s
            s
            m
            youth_m
            l
            youth_l
            xl
            youth_xl
            xxl
            xxxl
            xxxxl
            xxxxxl
          }
          is_preexisting_stock
          date_ordered
          stock_delivery_date
      }
    }`;

    return isEmptyObject(params)
      ? {
          operationName: null,
          query,
        }
      : {
          operationName: null,
          query,
          variables: params,
        };
  },
  CREATE_BLANK_STOCK_ORDER_DROPS: (params: object) => {
    const query = `mutation CreateBlankStockOrderDrops ($data: [BlankStockOrderDropInput!]) {
      createBlankStockOrderDrops(data: $data) {
          id
          blank_type
          blank_color
          blank_supplier {
            id
            name
          }
          stock_order_ref
          stock_cost_price
          stock_order_quantity {
            xs
            youth_s
            s
            m
            youth_m
            l
            youth_l
            xl
            youth_xl
            xxl
            xxxl
            xxxxl
            xxxxxl
          }
          is_preexisting_stock
          date_ordered
          stock_delivery_date
      }
    }`;

    return isEmptyObject(params)
      ? {
          operationName: null,
          query,
        }
      : {
          operationName: null,
          query,
          variables: params,
        };
  },

  CREATE_BRAND: (params: object) => {
    const query = `mutation CreateBrand ($data: CreateBrandInput!) {
      createBrand(data: $data) {
        name
        transportFob
        transportLanded
        vatFob
        vatLanded
        discountFob
        discountLanded
        transportMethodFob
        transportMethodLanded
        departments {
          name
        }
      }
    }`;

    return isEmptyObject(params)
      ? {
          operationName: null,
          query,
        }
      : {
          operationName: null,
          query,
          variables: params,
        };
  },
  UPDATE_BRAND: (params: object) => {
    const query = `mutation UpdateBrand ($data: UpdateBrandInput!) {
      updateBrand(data: $data) {
        id
        name
        transportFob
        transportLanded
        vatFob
        vatLanded
        discountFob
        discountLanded
        transportMethodFob
        transportMethodLanded
        departments {
          name
        }
      }
    }`;

    return isEmptyObject(params)
      ? {
          operationName: null,
          query,
        }
      : {
          operationName: null,
          query,
          variables: params,
        };
  },
  DELETE_BRAND: (params: object) => {
    const query = `mutation DeleteBrand ($id: Int!) {
      deleteBrand(id: $id) {
        status
      }
    }`;
    const args = { operationName: null, query };

    return isEmptyObject(params) ? args : { ...args, variables: params };
  },
  CREATE_ORDER_CONFIRMATION: (params: object) => {
    const query = `mutation CreateOrderConfirmation($data: CreateOrderConfirmationInput!) {
      createOrderConfirmation (data: $data) {
        id
        author {
          id
          firstname
          lastname
          email
        }
        assigned_user {
          id
          firstname
          lastname
          email
        }
        brand {
          id
          name
          departments {
            id
            name
          }
        }
        factory_1 {
          id
          name
          street_line_1
          city
          country
          phone_number
        }
        factory_2 {
          id
          name
          street_line_1
          city
          country
          phone_number
        }
        department {
          id
          name
        }
        status {
          id
          status
        }
        pf_style_number
        country_of_production
        sales_price_currency
        cost_price_currency
        transport_method
        shape
        brand_ref_number_1
        brand_ref_number_2
        fabric_weight
        fabric_weight_sample
        fabric_composition
        fabric_composition_sample
        transport_method
        print_type
        print_type_sample
        notes
        no_of_print_moulds
        wash
        wash_sample
        trims
        trims_sample
        fit_stage
        sales_price
        cost_price
        transport
        duty_tariff
        drops_to_delete {
          id
        }
        order_confirmation_drop {
          id
          image_url
          critical_path {
            id
            test_report
            status {
              id
              status
            }
            delivered_quantity
            labels_ordered
            comment
            po_sent
            revised_collection_date
            createdOn
            modifiedOn
          }
          description
          color
          blank_garment
          labels_other
          other
          embellishments_trims
          print
          washing
          license_fee
          packaging_labelling_processing
          pantone_ref
          agreed_delivery_date
          factory_exit_date
          createdOn
          modifiedOn
          blank_stock_order {
            id
            pf_style_number
            delivery_destination {
              id
              name
              street_line_1
              city
              country
              phone_number
            }
            total_quantity
            avg_price_per_unit
            createdOn
            modifiedOn
            blank_stock_order_drop {
              id
              status {
                id
                status
              }
              stock_order_ref
              stock_cost_price
              is_preexisting_stock
              blank_supplier {
                id
                name
              }
              stock_order_quantity {
                xs
                youth_s
                s
                m
                youth_m
                l
                youth_l
                xl
                youth_xl
                xxl
                xxxl
                xxxxl
                xxxxxl
              }
              date_ordered
              stock_delivery_date
              blank_color
              blank_type
            }
          }
        }
      }
    }`;

    return isEmptyObject(params)
      ? {
          operationName: null,
          query,
        }
      : {
          operationName: null,
          query,
          variables: params,
        };
  },
  DELETE_ORDER_CONFIRMATION: (params: object) => {
    const query = `mutation DeleteOrderConfirmation($id: Int!) {
    deleteOrderConfirmation(id:$id){
        status
      }
    }`;

    return isEmptyObject(params)
      ? {
          operationName: null,
          query,
        }
      : {
          operationName: null,
          query,
          variables: params,
        };
  },
  UPDATE_ORDER_CONFIRMATION: (params: object) => {
    const query = `mutation UpdateOrderConfirmation($data: UpdateOrderConfirmationInput!) {
      updateOrderConfirmation (data: $data) {
        id
        author {
          id
          firstname
          lastname
          email
        }
        assigned_user {
          id
          firstname
          lastname
          email
        }
        brand {
          id
          name
          departments {
            id
            name
          }
        }
        factory_1 {
          id
          name
          street_line_1
          city
          country
          phone_number
        }
        factory_2 {
          id
          name
          street_line_1
          city
          country
          phone_number
        }
        cost_price
        status{
          id
          status
        }
        pf_style_number
        country_of_production
        sales_price_currency
        cost_price_currency
        transport_method
        shape
        brand_ref_number_1
        brand_ref_number_2
        fabric_weight
        fabric_weight_sample
        fabric_composition
        fabric_composition_sample
        amended_count
        transport_method
        print_type
        print_type_sample
        notes
        no_of_print_moulds
        wash
        wash_sample
        trims
        trims_sample
        fit_stage
        sales_price
        cost_price
        transport
        duty_tariff
        drops_to_delete {
          id
        }
        order_confirmation_drop {
          id
          image_url
          stock_total_quantity
          description
          color
          blank_garment
          labels_other
          embellishments_trims
          print
          washing
          license_fee
          other
          packaging_labelling_processing
          pantone_ref
          agreed_delivery_date
          factory_exit_date
          createdOn
          modifiedOn
          critical_path {
            id
            test_report
            status {
               id
               status
            }
            delivered_quantity
            labels_ordered
            comment
            po_sent
            revised_collection_date
            createdOn
            modifiedOn
          }
          blank_stock_order {
            id
            pf_style_number
            delivery_destination {
              id
              name
              street_line_1
              city
              country
              phone_number
            }
            total_quantity
            avg_price_per_unit
            createdOn
            modifiedOn
            blank_stock_order_drop {
              id
              status  {
                id
                status
              }
              stock_order_ref
              stock_cost_price
              is_preexisting_stock
              blank_supplier {
                id
                name
              }
              is_preexisting_stock
              stock_order_quantity {
                id
                xs
                youth_s
                s
                m
                youth_m
                l
                youth_l
                xl
                youth_xl
                xxl
                xxxl
                xxxxl
                xxxxxl
              }
              date_ordered
              stock_delivery_date
              blank_color
              blank_type
            }
          }
        }
      }
    }`;

    return isEmptyObject(params)
      ? {
          operationName: null,
          query,
        }
      : {
          operationName: null,
          query,
          variables: params,
        };
  },
  UPDATE_USER_CRED: (params: object) => {
    const query = `mutation UpdateCredentials($input: UpdateUserCredentialsInput) {
      updateCredentials(cred: $input) {
        id,
        firstname,
        lastname,
        title,
        email,
        createdOn,
        modifiedOn
      }
  }`;

    return isEmptyObject(params)
      ? {
          operationName: null,
          query,
        }
      : {
          operationName: null,
          query,
          variables: params,
        };
  },
  CREATE_GROUP: (params: object) => {
    const query = `mutation CreateGroup ($input: CreateGroupInput!) {
      createGroup(data: $input) {
        id
        name
        description
      }
    }`;

    return isEmptyObject(params)
      ? {
          operationName: null,
          query,
        }
      : {
          operationName: null,
          query,
          variables: params,
        };
  },
  UPDATE_GROUP: (params: object) => {
    const query = `mutation UpdateGroup ($input: UpdateGroupInput!) {
      updateGroup(data: $input) {
        id
      }
    }`;

    return isEmptyObject(params)
      ? {
          operationName: null,
          query,
        }
      : {
          operationName: null,
          query,
          variables: params,
        };
  },
  DELETE_GROUP: (params: object) => {
    const query = `mutation DeleteGroup ($id: Int!) {
      deleteGroup(id: $id) {
        status
      }
    }`;
    const args = { operationName: null, query };
    return isEmptyObject(params) ? args : { ...args, variables: params };
  },
  CREATE_BLANK_STOCK_PROFILE: (params: object) => {
    const query = `mutation CreateBlankStockProfile ($input: CreateBlankStockProfileInput!) {
      createBlankStockProfile(data: $input) {
        id
        brand_name
        style_colour {
          name
        }
      }
    }`;

    return isEmptyObject(params)
      ? {
          operationName: null,
          query,
        }
      : {
          operationName: null,
          query,
          variables: params,
        };
  },
  UPDATE_BLANK_STOCK_PROFILE: (params: object) => {
    const query = `mutation UpdateBlankStockProfile ($input: UpdateBlankStockProfileInput!) {
      updateBlankStockProfile(data: $input) {
        id
        brand_name
        style_colour {
          name
        }
      }
    }`;

    return isEmptyObject(params)
      ? {
          operationName: null,
          query,
        }
      : {
          operationName: null,
          query,
          variables: params,
        };
  },
  DELETE_BLANK_STOCK_PROFILE: (params: object) => {
    const query = `mutation DeleteBlankStockProfile ($id: Int!) {
      deleteBlankStockProfile(id: $id) {
        status
      }
    }`;
    const args = { operationName: null, query };

    return isEmptyObject(params) ? args : { ...args, variables: params };
  },
  CREATE_FACTORY: (params: object) => {
    const query = `mutation CreateFactory ($input: CreateFactoryInput!) {
      createFactory(data: $input) {
        id
        name
        street_line_1
        street_line_2
        suburb
        city
        postal_code
        country
        email_addresses {
          default
          address
        }
        phone_number
        transport_markup
        discount_on_cost_price
      }
    }`;

    return isEmptyObject(params)
      ? {
          operationName: null,
          query,
        }
      : {
          operationName: null,
          query,
          variables: params,
        };
  },
  UPDATE_FACTORY: (params: object) => {
    const query = `mutation UpdateFactory ($input: UpdateFactoryInput!) {
      updateFactory(data: $input) {
        id
        name
        street_line_1
        street_line_2
        suburb
        city
        postal_code
        country
        email_addresses {
          default
          address
        }
        phone_number
        transport_markup
        discount_on_cost_price
      }
    }`;

    return isEmptyObject(params)
      ? {
          operationName: null,
          query,
        }
      : {
          operationName: null,
          query,
          variables: params,
        };
  },
  DELETE_FACTORY: (params: object) => {
    const query = `mutation DeleteFactory ($id: Int!) {
      deleteFactory(id: $id) {
        status
      }
    }`;
    const args = { operationName: null, query };

    return isEmptyObject(params) ? args : { ...args, variables: params };
  },
  CREATE_USER: (params: object) => {
    const query = `mutation CreateUser($input: CreateUserInput!) {
            createUser(user: $input) {
              id,
              firstname,
              lastname,
              email,
              title,
              role{
              id
              roleDescription
              },
            }
        }`;

    return isEmptyObject(params)
      ? {
          operationName: null,
          query,
        }
      : {
          operationName: null,
          query,
          variables: params,
        };
  },
  UPDATE_USER: (params: object) => {
    const query = `mutation UpdateUser ($input: UpdateUserInput!) {
      updateUser(user: $input) {
        firstname,
        lastname,
        title,
        role{
          id
          roleDescription
         },
      }
    }`;

    return isEmptyObject(params)
      ? {
          operationName: null,
          query,
        }
      : {
          operationName: null,
          query,
          variables: params,
        };
  },
  DELETE_USER: (params: object) => {
    const query = `mutation DeleteUser ($id: Int!) {
      deleteUser(userId: $id) {
        status
      }
    }`;
    const args = { operationName: null, query };

    return isEmptyObject(params) ? args : { ...args, variables: params };
  },
  REACTIVATE_USER: (params: object) => {
    const query = `mutation ReactivateUser ($id: Int!) {
      reactivateUser(userId: $id) {
        status
      }
    }`;
    const args = { operationName: null, query };

    return isEmptyObject(params) ? args : { ...args, variables: params };
  },
  UPDATE_CRITICAL_PATH: (params: object) => {
    const query = `mutation UpdateCriticalPath ($data: UpdateCriticalPathInput!) {
      updateCriticalPath(data: $data) {
        id
        status {
        id
        status
        }
        modifiedBy{
        id
        firstname
        lastname
        }
      }
    }`;

    return isEmptyObject(params)
      ? {
          operationName: null,
          query,
        }
      : {
          operationName: null,
          query,
          variables: params,
        };
  },
  ACTIVITY_LOG_CRITICAL_PATH_EDIT: (params: object) => {
    const query = `mutation CreateActivityLogForCriticalPathEdit ($data: ActivityLogCriticalPathEditInput!) {
      createActivityLogForCriticalPathEdit(data: $data) {
        status
      }
    }`;

    return isEmptyObject(params)
      ? {
          operationName: null,
          query,
        }
      : {
          operationName: null,
          query,
          variables: params,
        };
  },
  UPDATE_BLANK_STOCK_ORDER_DROP: (params: object) => {
    const query = `mutation UpdateBlankStockOrderDrop ($data: UpdateBlankStockOrderDropInput!) {
      updateBlankStockOrderDrop(data: $data) {
        id
      }
    }`;

    return isEmptyObject(params)
      ? {
          operationName: null,
          query,
        }
      : {
          operationName: null,
          query,
          variables: params,
        };
  },
  UPDATE_BLANK_STOCK_ORDER_DROPS: (params: object) => {
    const query = `mutation UpdateBlankStockOrderDrops ($data: [UpdateBlankStockOrderDropInput!], $parentId: Int) {
      updateBlankStockOrderDrops(data: $data, parentId: $parentId) {
        id
        status {
          id
          status
        }
      }
    }`;

    return isEmptyObject(params)
      ? {
          operationName: null,
          query,
        }
      : {
          operationName: null,
          query,
          variables: params,
        };
  },
  DELETE_BLANK_STOCK_ORDER_DROP: (params: object) => {
    const query = `mutation DeleteBlankStockOrderDrop ($bsodId: Int!) {
      deleteBlankStockOrderDrop(bsodId: $bsodId) {
        status
      }
    }`;
    const args = { operationName: null, query };

    return isEmptyObject(params) ? args : { ...args, variables: params };
  },
};

export default mOperations as {
  [key: string]: Function;
};
